/** A SMuFL glyph centred in a square (palette buttons, toolbar), using the same bbox centring as stamps. */
import type { SmuflGlyph } from '../../shared/smufl';
import { glyphFitSize, glyphOrigin } from './geometry';

const BOX = 100;

export function GlyphIcon({ glyph, size = 44, color = 'currentColor', fill = 0.72 }: { glyph: SmuflGlyph; size?: number; color?: string; fill?: number }) {
  const em = glyphFitSize(glyph, BOX * fill, BOX * 0.8);
  const o = glyphOrigin(glyph, em, BOX / 2, BOX / 2);
  return (
    <svg viewBox={`0 0 ${BOX} ${BOX}`} width={size} height={size} aria-hidden className="shrink-0 overflow-visible">
      <text x={o.x} y={o.y} fontSize={em} fill={color} className="smufl">
        {glyph.text}
      </text>
    </svg>
  );
}
